import { render, staticRenderFns } from "./UIKit.vue?vue&type=template&id=53f7406e&"
import script from "./UIKit.vue?vue&type=script&lang=ts&"
export * from "./UIKit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports